export function getDepartmentClassLabel(person, options = {}) {
  if (!person) return "";
  const { showDepartment = true } = options;

  const department = person.department || person.grade || "";
  const className = person.class || "";

  if (!showDepartment) {
    return className;
  }

  return [department, className].filter(Boolean).join(" · ");
}
